<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12 col-sm-12 mb-3">
        <div class="card p-4">
          <div class="media">
            <div class="avatar-sm mr-3">
              <span
                class="
                  avatar-title
                  rounded-circle
                  bg-light
                  text-primary
                  border-primary
                  font-size-22
                "
              >
                <i class="bx bx-search bx-md"></i>
              </span>
            </div>
            <div class="media-body">
              <h5 class="mt-3">{{ $t("education.career-search") }}</h5>
            </div>
          </div>
          <div class="row mt-5 pb-3">
            <div class="col-sm-12 text-right">
              <div class="input-group pb-3">
                <input
                  id="search"
                  type="text"
                  class="form-control"
                  v-model="searchKey"
                  placeholder="nama.."
                  aria-describedby="search"
                  @keyup.enter="SearchNama"
                />
                <div class="input-group-prepend">
                  <button
                    id="search"
                    class="input-group-text bg-primary text-white"
                    @click="SearchNama"
                    v-on:keyup="SearchNama"
                  >
                    <i class="bx bx-search-alt search-icon"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-sm-12 font-weight-bold">
              <table v-if="id_target && target.length != 0">
                <tr>
                  <td>Target Profile</td>
                  <td>:</td>
                  <td>{{ target.title }}</td>
                </tr>
              </table>
            </div>
          </div>
          <div v-if="loading" class="row mt-4 mx-auto">
            <div class="text-center p-5">
              <div class="spinner-border text-secondary" role="status"></div>
              <p>{{ $t("education.search-data") }} ..</p>
            </div>
          </div>
          <div
            v-if="error !== '' && !loading"
            class="row mt-5 mb-5 pb-4 mx-auto"
          >
            <div class="text-center">
              <span class="text-secondary">{{ error }}</span>
            </div>
          </div>
          <div
            v-if="total === 0 && !loading"
            class="row mt-5 mb-5 pb-4 mx-auto"
          >
            <div class="text-center">
              <span class="text-secondary">{{ $t("all.dnf") }}</span>
            </div>
          </div>
          <div class="row" v-if="total > 0 && !loading">
            <div
              v-for="(res, index) in result.results"
              :key="index"
              class="col-xl-3 col-sm-6 mb-4"
            >
              <div class="card text-center h-100">
                <div class="card-body" :class="theme == 'dark' ? 'bgd' : 'bgx'">
                  <div>
                    <img
                      src="https://static-exp1.licdn.com/sc/h/244xhbkr7g40x6bsu4gi6q4ry"
                      class="rounded-circle avatar-xl"
                      v-if="res.image_url == null"
                    />
                    <img
                      :src="res.image_url"
                      alt=""
                      srcset=""
                      class="rounded-circle avatar-xl"
                      v-else
                    />
                  </div>
                  <h5 class="font-size-15 mt-2">
                    <a href="javascript: void(0);" class="text-dark">{{
                      res.title
                    }}</a>
                  </h5>
                  <a
                    :href="'https://www.linkedin.com/in/' + res.universal_id"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text-muted"
                    >{{ res.universal_id }}</a
                  >
                  <div></div>
                </div>
                <div class="card-footer bg-transparent border-top px-5">
                  <router-link
                    :to="{
                      name: 'detail-career',
                      params: { id: res.universal_id },
                    }"
                    target="_blank"
                    ><b-button
                      class="btn-sm mt-1 mb-1 btn-block"
                      variant="primary"
                    >
                      {{ $t("education.view-detail") }}
                    </b-button></router-link
                  >
                  <b-button
                    v-if="id_target && target.length != 0"
                    class="btn-sm mt-1 mb-1 btn-block"
                    variant="primary"
                    @click="addToTarget(res.universal_id)"
                  >
                    {{ $t("education.add-target") }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from "moment";
import EducationService from "@/helpers/education.service";
import PreferenceService from "@/helpers/preference.service.js";
import TargetService from "@/helpers/target-profile.service";
import SocmedService from "@/helpers/socmed.service";
import GroupService from "@/helpers/group.service";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Carrer Search",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: this.$t("education.career-search"),
          active: true,
        },
      ],
      title: this.$t("education.career-search"),
      theme: localStorage.getItem('theme'),
      loadingGrup: false,
      loading: false,
      loadinglist: false,
      loadingAdd: false,
      search: false,
      total: "",
      error: "",
      searchKey: "",
      result: [],
      error: "",
      is_spam: "",
      search: false,
      pref: "",
      pref2: "",
      api_host: "",
      x_rapidapi_host: "",
      x_rapidapi_key: "",
      api_host2: "",
      x_rapidapi_host2: "",
      x_rapidapi_key2: "",
      id_target: this.$route.query.target,
      target: [],
      targetDetail: "",
    };
  },
  methods: {
    SearchNama() {
      if (this.searchKey != "") {
        this.error = "";
        this.total = "";
        this.search = true;
        this.loading = true;
        this.result = [];
        let headers = {
          "content-type": "application/json",
          "x-rapidapi-host": this.x_rapidapi_host,
          "x-rapidapi-key": this.x_rapidapi_key,
        };
        let data = {
          keyword: this.searchKey,
          search_type: "people",
          location: "",
          size: "11-50",
          per_page: 20,
          offset: 0,
        };
        return axios
          .post(this.api_host, data, { headers: headers })
          .then((response) => {
            this.result = response.data;
            let total = response.data.pagination["total"];
            this.total = total;
            this.loading = false;
          })
          .catch((err) => {
            console.log(err);
            this.search = false;
            this.loading = false;
            if (err.response.status == 500) {
              this.error = "Internal server Error";
            } else if (err.response.status == 404) {
              this.error = "Server Not Found";
            } else if (err.response.status == 403) {
              this.error = "Forbidden";
            }
          });
      }
    },

    async addToTarget(id) {
      await this.getDetailCareer(id);
      await this.AddCarrer();
    },

    AddCarrer() {
      let data = {
        id_target: this.id_target,
        profile_id: this.targetDetail.profile_id,
        first_name: this.targetDetail.first_name,
        last_name: this.targetDetail.last_name,
        profile_picture: this.targetDetail.profile_picture,
        profile_positions: JSON.stringify(this.targetDetail.position_groups),
        skills: JSON.stringify(this.targetDetail.skills),
        certifications: JSON.stringify(this.targetDetail.certifications),
        publications: JSON.stringify(this.targetDetail.publications),
      };
      EducationService.SaveCareer(data)
        .then((response) => {
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.$router.push({
            name: "project-overview",
            params: { id: this.id_target },
          });
          // this.$router.push('/career-search');
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getDetailCareer(id) {
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.x_rapidapi_host2,
        "x-rapidapi-key": this.x_rapidapi_key2,
      };
      let data = {
        profile_id: id,
        profile_type: "personal",
        contact_info: true,
        recommendations: false,
        related_profiles: true,
      };
      return axios
        .post(this.api_host2, data, { headers: headers })
        .then((response) => {
          console.log("asda ", response);
          this.targetDetail = response.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getTargetProfile() {
      if (this.id_target != "" && this.id_target != null) {
        TargetService.getDetailTarget(this.id_target)
          .then((response) => {
            let data = {
              title: response.data.data.title,
              id: response.data.data.id_target,
            };
            this.target = data;
          })
          .catch((err) => {
            console.log("err ", err);
          });
      }
    },

    getPreferences() {
      let id = 1;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          this.pref = response.data.data;
          this.api_host = response.data.data.api_host;
          this.x_rapidapi_host = response.data.data.api_header_host;
          this.x_rapidapi_key = response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getPreferences2() {
      let id = 2;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          this.pref2 = response.data.data;
          this.api_host2 = response.data.data.api_host;
          this.x_rapidapi_host2 = response.data.data.api_header_host;
          this.x_rapidapi_key2 = response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    formatDate(value) {
      return moment(value).format("dddd, YYYY-MM-DD hh:mm");
    },
  },
  beforeMount() {
    this.getPreferences();
    this.getPreferences2();
    this.getTargetProfile();
  },
};
</script>

<style scoped>
.loading {
  padding-top: 20%;
  padding-bottom: 20%;
}
.bgx {
  background-color: #f7f7fa;
}
.bgd {
  background-color: #1E222E;
}
</style>

